<div #container class="nc-grainient-canvas-container"></div>
<div class="nc-content-wrapper">
  <ng-content></ng-content>
</div>